import { render, staticRenderFns } from "./NavDrawer.vue?vue&type=template&id=b0054cbc&scoped=true"
import script from "./NavDrawer.vue?vue&type=script&lang=js"
export * from "./NavDrawer.vue?vue&type=script&lang=js"
import style0 from "./NavDrawer.vue?vue&type=style&index=0&id=b0054cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0054cbc",
  null
  
)

export default component.exports